import {
	usePublishModalMountActions as usePublishModalMountStateActions,
	usePublishModalMountStore as usePublishModalMountStateStore,
} from '@confluence/publish-modal-state/entry-points/PublishModalMountState.ts';
import type { PublishModalSource as PublishModalStateSource } from '@confluence/publish-modal-state/entry-points/PublishModalMountState.ts';

export type PublishModalSource = PublishModalStateSource;

export const usePublishModalMountStore = usePublishModalMountStateStore;
export const usePublishModalMountActions = usePublishModalMountStateActions;
